import { render, staticRenderFns } from "./AutoShow2024.vue?vue&type=template&id=2542443c&scoped=true&"
import script from "./AutoShow2024.vue?vue&type=script&lang=js&"
export * from "./AutoShow2024.vue?vue&type=script&lang=js&"
import style0 from "./AutoShow2024.vue?vue&type=style&index=0&id=2542443c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542443c",
  null
  
)

export default component.exports